import { Box } from "@mui/material";
import HeaderBar from "../components/HeaderBar";
import "react-toastify/dist/ReactToastify.css";
import Toast from "../components/Toast";
import { Outlet } from "react-router-dom";

const Layout: React.FC = () => {
    return (
        <Box>
            <Toast /> {/* Notification Component */}
            <HeaderBar /> {/* Header Bar */}
            <Box sx={{ padding: 2 }}> {/* Main Content Area */}
                <Outlet /> {/* This renders the child route component */}
            </Box>
        </Box>
    );
  };
export default Layout;
